import React, { createContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import TuneSharpIcon from '@material-ui/icons/TuneSharp'
import TransferWithinAStationSharpIcon from '@material-ui/icons/TransferWithinAStationSharp'
import PostAddSharpIcon from '@material-ui/icons/PostAddSharp'
import LocalShippingSharpIcon from '@material-ui/icons/LocalShippingSharp'
import LocalPrintshopSharpIcon from '@material-ui/icons/LocalPrintshopSharp'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import CheckIcon from '@material-ui/icons/Check'
import InvoiceCreateStep1 from '../components/Invoice/Steps/Step1'
import ListingServices from '../Services/Consumers/ListingServices'
import { InvoiceSignatureSubmitPayload, InvoiceSubmitPayload } from '../Services/Payloads/InvoicePayload'
import InvoiceCreateStep2 from '../components/Invoice/Steps/Step2'
import { AuthConsumer } from './AuthContext'
import InvoiceCreateStep3 from '../components/Invoice/Steps/Step3'
import InvoiceCreateStep6 from '../components/Invoice/Steps/Step6'
import InvoiceCreateStep4 from '../components/Invoice/Steps/Step4'
import InvoiceCreateStep5 from '../components/Invoice/Steps/Step5'
import InvoiceCreateStep7 from '../components/Invoice/Steps/Step7'
import receiverTypes from '../configurations/receiver-types'
import countryCodes from '../configurations/country-codes'
import { calculateDecimal, filterData, handleNotificationAlert } from '../utils/helpers'
import taxTypes from '../configurations/tax-types'
import nonTaxableTaxTypes from '../configurations/non-taxable-tax-types'
import currencyList from '../configurations/currency-codes'
import taxSubtypes from '../configurations/tax-subtypes'
import { useKeycloak } from '@react-keycloak/web'
import AuthServices from '../Services/Consumers/AuthServices'
import Configuration from '../Services/Api/Configuration'
import { NamedRoutes } from '../routes'

const CreateInvoiceContext = createContext({})

const CreateInvoiceProvider = ({ children, savedEntityId, savedEntityType, locale, trn }) => {
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  let history = useHistory()
  const [invoiceData, setInvoiceData] = React.useState({})
  const [savedTemplateData, setSavedTemplateData] = React.useState(null)
  const [draftInvoiceLoading, setDraftInvoiceLoading] = React.useState(false)
  // {
  //   'step1': {
  //     'documentType': 'I',
  //     'documentTypeVersion': '1.0',
  //     'documentSubType': 'full',
  //     'internalID': 630361516284,
  //     'generatedInternalID': 630361516284,
  //     'internalIDEdit': false,
  //     'dateTimeIssued': '2022-06-08T13:48:22.000Z',
  //     'dateTimeIssuedEdit': false,
  //     'references': []
  //   },
  //   'step2': {
  //     'taxpayerActivityCode': '0472',
  //     'issuerType': 'B',
  //     'issuerID': 628787103,
  //     'issuerName': 'اركديف ش ذ م م م',
  //     'issuerBranchID': '0',
  //     'issuerAddress': {
  //       'country': 'EG',
  //       'countryName': 'Egypt',
  //       'governate': 'Ismailia',
  //       'regionCity': 'Ismailia',
  //       'street': 'وحده رقم6 بمبني مجمع خدمات المنطقه الحره بالاسماعيليه',
  //       'buildingNumber': '00000',
  //       'floor': '',
  //       'room': '',
  //       'landmark': '',
  //       'postalCode': '00000',
  //       'additionalInformation': ' '
  //     },
  //     'receiverType': 'F',
  //     'receiverID': '10201020102',
  //     'receiverName': 'Sattar test',
  //     'receiverAddress': {
  //       'countryName': 'France',
  //       'country': 'FR',
  //       'governate': 'Cairo',
  //       'regionCity': 'Nasr City',
  //       'street': 'Ryada street',
  //       'buildingNumber': '5',
  //       'floor': '8',
  //       'room': '802',
  //       'landmark': 'Gnena Mall',
  //       'postalCode': '12500',
  //       'additionalInformation': 'Gnena Mall'
  //     }
  //   },
  //   'step3': {
  //     'invoiceLines': [
  //       {
  //         'id': 1,
  //         'itemType': 'GS1',
  //         'itemCode': '1000000000003',
  //         'description': 'شاكوش صلب 2 ك',
  //         'itemObject': {},
  //         'internalCode': 'pr-ar-124',
  //         'unitCalculatedValue': 0,
  //         'unitAmount': 185.5,
  //         'currencyRate': {
  //           'key': 'EGP',
  //           'rate': 1
  //         },
  //         'amountSold': 'EGP',
  //         'unitType': 'KGM',
  //         'quantity': 3,
  //         'calculatedSalesTotal': 556.5,
  //         'salesTotalEdit': false,
  //         'salesTotal': 556.5,
  //         'discountRate': '3.00',
  //         'discountValue': 16.695,
  //         'discountValueEdit': false,
  //         'discountCalculatedValue': 16.695,
  //         'netTotal': 539.805,
  //         'netTotalEdit': false,
  //         'calculatedNetTotal': 539.805,
  //         'taxableItems': [
  //           {
  //             'id': 1,
  //             'type': 'T3',
  //             'typeName': 'Table tax (Fixed Amount)',
  //             'subType': 'Tbl02',
  //             'subTypeName': 'Table tax (Fixed Amount)',
  //             'rate': 0,
  //             'value': 12.5,
  //             'calculatedValue': '0.00',
  //             'valueEdit': true,
  //             'fixedAmount': true,
  //             'icon': {
  //               'type': {
  //                 'type': {},
  //                 'compare': null
  //               },
  //               'key': null,
  //               'ref': null,
  //               'props': {},
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'headerTitle': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Table tax (Fixed Amount)',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T3',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   },
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'className': 'tax-header-value',
  //                       'children': [
  //                         '(',
  //                         {
  //                           'type': 'strong',
  //                           'key': null,
  //                           'ref': null,
  //                           'props': {
  //                             'children': [
  //                               12.5,
  //                               ' ',
  //                               'EGP'
  //                             ]
  //                           },
  //                           '_owner': null,
  //                           '_store': {}
  //                         },
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'name': 'Table tax (Fixed Amount)',
  //             'typeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Table tax (Fixed Amount)',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T3',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'subTypeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Table tax (Fixed Amount)',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'Tbl02',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'rateView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   0,
  //                   ' %'
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'valueView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'className': 'tax-header-value',
  //                 'children': {
  //                   'type': 'strong',
  //                   'key': null,
  //                   'ref': null,
  //                   'props': {
  //                     'children': [
  //                       12.5,
  //                       ' ',
  //                       'EGP'
  //                     ]
  //                   },
  //                   '_owner': null,
  //                   '_store': {}
  //                 }
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             }
  //           },
  //           {
  //             'id': 2,
  //             'type': 'T7',
  //             'typeName': 'Entertainment tax',
  //             'subType': 'Ent01',
  //             'subTypeName': 'Entertainment tax (rate)',
  //             'rate': '10.00',
  //             'value': 53.9805,
  //             'calculatedValue': 53.9805,
  //             'valueEdit': false,
  //             'fixedAmount': false,
  //             'icon': {
  //               'type': {
  //                 'type': {},
  //                 'compare': null
  //               },
  //               'key': null,
  //               'ref': null,
  //               'props': {},
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'headerTitle': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Entertainment tax',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T7',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   },
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'className': 'tax-header-value',
  //                       'children': [
  //                         '(',
  //                         {
  //                           'type': 'strong',
  //                           'key': null,
  //                           'ref': null,
  //                           'props': {
  //                             'children': [
  //                               53.9805,
  //                               ' ',
  //                               'EGP'
  //                             ]
  //                           },
  //                           '_owner': null,
  //                           '_store': {}
  //                         },
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'name': 'Entertainment tax',
  //             'typeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Entertainment tax',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T7',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'subTypeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Entertainment tax (rate)',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'Ent01',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'rateView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   '10.00',
  //                   ' %'
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'valueView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'className': 'tax-header-value',
  //                 'children': {
  //                   'type': 'strong',
  //                   'key': null,
  //                   'ref': null,
  //                   'props': {
  //                     'children': [
  //                       53.9805,
  //                       ' ',
  //                       'EGP'
  //                     ]
  //                   },
  //                   '_owner': null,
  //                   '_store': {}
  //                 }
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             }
  //           },
  //           {
  //             'id': 3,
  //             'type': 'T1',
  //             'typeName': 'Value added tax',
  //             'subType': 'V001',
  //             'subTypeName': 'Export',
  //             'rate': '14.00',
  //             'value': 84.87997,
  //             'calculatedValue': 84.87997,
  //             'valueEdit': false,
  //             'fixedAmount': false,
  //             'icon': {
  //               'type': {
  //                 'type': {},
  //                 'compare': null
  //               },
  //               'key': null,
  //               'ref': null,
  //               'props': {},
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'headerTitle': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Value added tax',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T1',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   },
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'className': 'tax-header-value',
  //                       'children': [
  //                         '(',
  //                         {
  //                           'type': 'strong',
  //                           'key': null,
  //                           'ref': null,
  //                           'props': {
  //                             'children': [
  //                               84.87997,
  //                               ' ',
  //                               'EGP'
  //                             ]
  //                           },
  //                           '_owner': null,
  //                           '_store': {}
  //                         },
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'name': 'Value added tax',
  //             'typeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Value added tax',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T1',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'subTypeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Export',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'V001',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'rateView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   '14.00',
  //                   ' %'
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'valueView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'className': 'tax-header-value',
  //                 'children': {
  //                   'type': 'strong',
  //                   'key': null,
  //                   'ref': null,
  //                   'props': {
  //                     'children': [
  //                       84.87997,
  //                       ' ',
  //                       'EGP'
  //                     ]
  //                   },
  //                   '_owner': null,
  //                   '_store': {}
  //                 }
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             }
  //           }
  //         ],
  //         'totalTaxableItems': 151.36047,
  //         'calculatedTaxesWithoutT1': 66.4805,
  //         'totalTaxableFees': 53.9805,
  //         'totalTaxableFeesEdit': false,
  //         'calculatedTotalTaxableFees': 53.9805,
  //         'valueDifference': 0,
  //         'itemsDiscount': 0,
  //         'total': 691.16547,
  //         'totalEdit': false,
  //         'calculatedTotal': 691.16547
  //       },
  //       {
  //         'id': 2,
  //         'itemType': 'GS1',
  //         'itemCode': '15000001230',
  //         'description': 'Activ Logo Print Shorts Burgundy N50307421A 1 Piece',
  //         'itemObject': {},
  //         'internalCode': 'pr-ar-126',
  //         'unitCalculatedValue': 0,
  //         'unitAmount': '255.00',
  //         'currencyRate': {
  //           'key': 'EGP',
  //           'rate': 1
  //         },
  //         'amountSold': 'EGP',
  //         'unitType': 'KGM',
  //         'quantity': 1,
  //         'calculatedSalesTotal': '255.00',
  //         'salesTotalEdit': false,
  //         'salesTotal': '255.00',
  //         'discountRate': '1.00',
  //         'discountValue': 2.55,
  //         'discountValueEdit': false,
  //         'discountCalculatedValue': 2.55,
  //         'netTotal': 252.45,
  //         'netTotalEdit': false,
  //         'calculatedNetTotal': 252.45,
  //         'taxableItems': [
  //           {
  //             'id': 1,
  //             'type': 'T1',
  //             'typeName': 'Value added tax',
  //             'subType': 'V001',
  //             'subTypeName': 'Export',
  //             'rate': '14.00',
  //             'value': 35.343,
  //             'calculatedValue': 35.343,
  //             'valueEdit': false,
  //             'fixedAmount': false,
  //             'icon': {
  //               'type': {
  //                 'type': {},
  //                 'compare': null
  //               },
  //               'key': null,
  //               'ref': null,
  //               'props': {},
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'headerTitle': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Value added tax',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T1',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   },
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'className': 'tax-header-value',
  //                       'children': [
  //                         '(',
  //                         {
  //                           'type': 'strong',
  //                           'key': null,
  //                           'ref': null,
  //                           'props': {
  //                             'children': [
  //                               35.343,
  //                               ' ',
  //                               'EGP'
  //                             ]
  //                           },
  //                           '_owner': null,
  //                           '_store': {}
  //                         },
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'name': 'Value added tax',
  //             'typeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Value added tax',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'T1',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'subTypeView': {
  //               'type': 'div',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   'Export',
  //                   ' ',
  //                   {
  //                     'type': 'span',
  //                     'key': null,
  //                     'ref': null,
  //                     'props': {
  //                       'children': [
  //                         ' (',
  //                         'V001',
  //                         ')'
  //                       ]
  //                     },
  //                     '_owner': null,
  //                     '_store': {}
  //                   }
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'rateView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'children': [
  //                   '14.00',
  //                   ' %'
  //                 ]
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             },
  //             'valueView': {
  //               'type': 'span',
  //               'key': null,
  //               'ref': null,
  //               'props': {
  //                 'className': 'tax-header-value',
  //                 'children': {
  //                   'type': 'strong',
  //                   'key': null,
  //                   'ref': null,
  //                   'props': {
  //                     'children': [
  //                       35.343,
  //                       ' ',
  //                       'EGP'
  //                     ]
  //                   },
  //                   '_owner': null,
  //                   '_store': {}
  //                 }
  //               },
  //               '_owner': null,
  //               '_store': {}
  //             }
  //           }
  //         ],
  //         'totalTaxableItems': 35.343,
  //         'calculatedTaxesWithoutT1': '0.00',
  //         'totalTaxableFees': '0.00',
  //         'totalTaxableFeesEdit': false,
  //         'calculatedTotalTaxableFees': '0.00',
  //         'valueDifference': 0,
  //         'itemsDiscount': 0,
  //         'total': 287.793,
  //         'totalEdit': false,
  //         'calculatedTotal': 287.793
  //       }
  //     ],
  //     'calculatedTotalSalesAmount': 0,
  //     'totalSalesAmountEdit': false,
  //     'totalSalesAmount': 811.5,
  //     'calculatedTotalDiscountAmount': 0,
  //     'totalDiscountAmountEdit': false,
  //     'totalDiscountAmount': 19.245,
  //     'calculatedNetAmount': 792.255,
  //     'netAmountEdit': false,
  //     'netAmount': 792.255,
  //     'currency': 'EGP',
  //     'calculatedTotalItemsDiscountAmount': '0.00',
  //     'totalItemsDiscountAmountEdit': false,
  //     'totalItemsDiscountAmount': '0.00',
  //     'taxTotals': [
  //       {
  //         'taxType': 'T3',
  //         'amount': 12.5,
  //         'amountEdit': false,
  //         'calculatedAmount': 12.5
  //       },
  //       {
  //         'taxType': 'T7',
  //         'amount': 53.9805,
  //         'amountEdit': false,
  //         'calculatedAmount': 53.9805
  //       },
  //       {
  //         'taxType': 'T1',
  //         'amount': 120.22297,
  //         'amountEdit': false,
  //         'calculatedAmount': 120.22297
  //       }
  //     ],
  //     'extraDiscountAmount': 9.6512,
  //     'calculatedTotalAmount': 969.30727,
  //     'totalAmountEdit': false,
  //     'totalAmount': 969.30727
  //   },
  //   'step4': {
  //     'purchaseOrderReference': 'Purchase Order Reference',
  //     'purchaseOrderDescription': 'Purchase Order Description',
  //     'salesOrderReference': 'Sales Order Reference',
  //     'salesOrderDescription': 'Sales Order Description',
  //     'proformaInvoiceNumber': 'Proforma Invoice Number',
  //     'bankName': 'Bank Name',
  //     'bankAddress': 'Bank Address',
  //     'bankAccountNo': 'Bank Account No',
  //     'bankAccountIBAN': 'AB01 2345 6789 ABC123',
  //     'swiftCode': 'ABCDEFAB123',
  //     'paymentTerms': 'Payment Terms'
  //   },
  //   'step5': {
  //     'approach': 'Approach',
  //     'packaging': 'Packaging',
  //     'dateValidity': '2022-06-10T17:05:10.223Z',
  //     'exportPort': 'Export Port',
  //     'grossWeight': 150,
  //     'netWeight': 156,
  //     'deliveryTerms': 'Delivery Terms'
  //   }
  // })

  const [hasReferences, setHasReferences] = React.useState(false)
  const [isCopyInvoice, setIsCopyInvoice] = React.useState(false)
  const [invoiceSubType, setInvoiceSubType] = React.useState('full')
  const [invoiceSubmissionLoading, setInvoiceSubmissionLoading] = React.useState(false)
  const [invoiceSubmissionUUID, setInvoiceSubmissionUUID] = React.useState('')
  const [isLocked, setIsLocked] = React.useState(false)
  const [invoicePersonalLimit, setInvoicePersonalLimit] = React.useState(0)
  const handleInvoiceSubTypeChange = (type) => {
    setInvoiceSubType(type)
  }
  const handleReferencesChange = (hasReference) => {
    setHasReferences(!!hasReference)
  }
  const invoiceStepSubmit = (values, FormikActions, key, locale, closeConfirmationDialog) => {
    if (!!keycloak?.authenticated) {
      if (key === 'step1' && !!values?.referencesList?.length) {
        if (!!savedEntityId && values?.referencesList?.length === values?.references?.length &&
          values?.referencesList?.map(ref => ref?.uuid)?.every(element => values?.originalReferences?.includes(element))) {
          handleNextStep()
        } else {
          getDataFromReferencesList(values?.referencesList, locale)
          setTimeout(() => {
            handleNextStep() //key === 'step1'
          }, 100)
        }
      } else {
        if (!!closeConfirmationDialog) {
          closeConfirmationDialog()
        } else {
          handleNextStep()
        }
      }
      setTimeout(() => {
        setInvoiceData((prevState) => ({ ...prevState, [key]: values }))
        // FormikActions.setSubmitting(false)
      }, 200)
    }
  }

  const [currencies, setCurrencies] = React.useState([{
    id: 0,
    key: 'EGP',
    name_en: 'Egyptian Pound',
    name_ar: 'جنيه مصري',
    rate: 1
  }])
  const updateCurrenciesList = (currencyList) => {
    setCurrencies(currencyList || [])
  }

  React.useEffect(() => {
      if (!!keycloak?.authenticated) {
        ListingServices.getSPConfigData(intl.formatMessage({ id: `getSPConfigData.Error` })
        ).then((result) => {
          if (!!result && !!result.data && !!result.data?.validateNID) {
            setInvoicePersonalLimit(result.data?.nidAmount || 0)
          }
        })
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  React.useEffect(() => {
      if (!!keycloak?.authenticated && !!savedEntityId) {
        setDraftInvoiceLoading(true)
        ListingServices.getSavedInvoiceEntityData(savedEntityId, savedEntityType, intl.formatMessage({ id: `SavedInvoice.${savedEntityType}.Error` })
        ).then((result) => {
          if (!!result && !!result.data) {
            let document = savedEntityType === 'invoice' ? result.data : result.data?.document
            let templateInvoice = ['template', 'invoice'].includes(savedEntityType)
            let isSimple = savedEntityType === 'invoice' ? (['C', 'D', 'EC', 'ED'].includes(result.data?.documentType?.toUpperCase()) ? 'simple' : 'full') : (!!result.data?.simple ? 'simple' : 'full')

            if (savedEntityType === 'template') {
              setSavedTemplateData({
                id: result.data?.id || savedEntityId,
                name: result.data?.name || '',
                privilegeId: result.data?.privilegeId || ''
              })
            }
            let internalId = Math.floor(100000000000 + Math.random() * 900000000000)
            setInvoiceSubType(isSimple)
            setIsCopyInvoice(savedEntityType === 'invoice' && !document?.references?.length)
            let invoice = {
              'step1': {
                documentType: document?.documentType?.toUpperCase() || 'I',
                documentTypeVersion: savedEntityType === 'invoice' ? '1.0' : (document?.documentTypeVersion || '1.0'),
                // documentTypeVersion: document?.documentTypeVersion !== '1.0' ? '' : (document?.documentTypeVersion || '1.0'),
                documentSubType: isSimple,
                internalID: templateInvoice ? internalId : (document?.internalID || ''),
                generatedInternalID: templateInvoice ? internalId : '',
                internalIDEdit: !templateInvoice,
                dateTimeIssued: templateInvoice ? '' : (document?.dateTimeIssued || ''),
                dateTimeIssuedEdit: !templateInvoice,
                serviceDeliveryDate: templateInvoice ? '' : (document?.serviceDeliveryDate || ''),
                serviceDeliveryDateEdit: !templateInvoice,
                references: document?.references || [],
                originalReferences: document?.references || [],
                referencesList: [],
                lastReferences: ''
              }
            }
            setInvoiceData((prevState) => ({ ...invoice, ...getDataFromReferencesList([document], locale, true, result.data?.trn, savedEntityType === 'invoice' && !document?.references?.length) }))
            document?.references?.forEach(ref => getInvoiceDetails(ref, ['EC', 'ED'].includes(document?.documentType?.toUpperCase())))

          }
        }).then(() => {
          setDraftInvoiceLoading(false)
        })
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [savedEntityId])

  // [
  //   {
  //     'submissionUUID': 'DFX5F25J1W9JFHCFJYYWTH5G10',
  //     'dateTimeRecevied': '2022-06-14T19:26:29.9208317Z',
  //     'validationResults': {
  //       'status': 'Valid',
  //       'validationSteps': [
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-04',
  //           'stepId': '11'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-03',
  //           'stepId': '6'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-05',
  //           'stepId': '14'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-06',
  //           'stepId': '15'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-07',
  //           'stepId': '16'
  //         }
  //       ]
  //     },
  //     'transformationStatus': 'original',
  //     'statusId': 2,
  //     'status': 'Valid',
  //     'documentStatusReason': null,
  //     'cancelRequestDate': '2022-06-14T19:29:09.5959702Z',
  //     'rejectRequestDate': null,
  //     'cancelRequestDelayedDate': null,
  //     'rejectRequestDelayedDate': null,
  //     'declineCancelRequestDate': '2022-06-14T19:58:07.9946459Z',
  //     'declineRejectRequestDate': null,
  //     'canbeCancelledUntil': '2022-06-17T19:26:28.2989498Z',
  //     'canbeRejectedUntil': '2022-06-15T07:26:28.2989498Z',
  //     'submissionChannel': 3,
  //     'uuid': 'HC2ZFE81W3YJAR8XKYYWTH5G10',
  //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/HC2ZFE81W3YJAR8XKYYWTH5G10/share/GDKMF53J60BJ3M0XKYYWTH5G10NDodFL1655234788',
  //
  //     'delivery': {
  //       'approach': null,
  //       'packaging': null,
  //       'dateValidity': null,
  //       'exportPort': null,
  //       'countryOfOrigin': null,
  //       'grossWeight': 0,
  //       'netWeight': null,
  //       'terms': null
  //     },
  //     'payment': {
  //       'bankName': null,
  //       'bankAddress': null,
  //       'bankAccountNo': null,
  //       'bankAccountIBAN': null,
  //       'swiftCode': null,
  //       'terms': null
  //     },
  //     'totalAmount': 36685,
  //     'taxTotals': [],
  //     'netAmount': 36685,
  //     'totalDiscount': 0,
  //     'totalSales': 36685,
  //     'invoiceLines': [
  //       {
  //         'itemPrimaryName': null,
  //         'itemPrimaryDescription': null,
  //         'itemSecondaryName': null,
  //         'itemSecondaryDescription': null,
  //         'unitTypePrimaryName': 'Kilogram ( KG )',
  //         'unitTypePrimaryDescription': '',
  //         'unitTypeSecondaryName': '',
  //         'unitTypeSecondaryDescription': '',
  //         'salesTotalForeign': 36685,
  //         'netTotalForeign': 36685,
  //         'totalForeign': 36685,
  //         'totalTaxableFeesForeign': 0,
  //         'itemsDiscountForeign': 0,
  //         'valueDifferenceForeign': 0,
  //         'discountForeign': {
  //           'amountForeign': 0,
  //           'rate': 0,
  //           'amount': 0
  //         },
  //         'lineTaxableItems': [],
  //         'description': 'Activ Logo Print Shorts Burgundy N50307421A 1 Piece',
  //         'itemType': 'GS1',
  //         'itemCode': '15000001230',
  //         'unitType': 'KGM',
  //         'quantity': 145,
  //         'unitValue': {
  //           'currencySold': 'EGP',
  //           'amountSold': null,
  //           'amountEGP': 253,
  //           'currencyExchangeRate': null
  //         },
  //         'factoryUnitValue': null,
  //         'salesTotal': 36685,
  //         'discount': {
  //           'rate': 0,
  //           'amount': 0
  //         },
  //         'taxableItems': null,
  //         'internalCode': 'pr-ar-126',
  //         'itemsDiscount': 0,
  //         'netTotal': 36685,
  //         'totalTaxableFees': 0,
  //         'valueDifference': 0,
  //         'total': 36685
  //       }
  //     ],
  //     'references': [],
  //     'purchaseOrderDescription': null,
  //     'totalItemsDiscountAmount': 0,
  //     'salesOrderDescription': null,
  //     'salesOrderReference': null,
  //     'proformaInvoiceNumber': null,
  //     'signatures': [],
  //     'purchaseOrderReference': null,
  //     'internalID': '83437178099',
  //     'taxpayerActivityCode': '0472',
  //     'dateTimeIssued': '2022-06-14T19:26:27Z',
  //     'documentTypeVersion': '0.9',
  //     'documentType': 'i',
  //     'documentTypeNamePrimaryLang': 'Invoice',
  //     'documentTypeNameSecondaryLang': 'فاتورة',
  //     'receiver': {
  //       'address': {
  //         'buildingNumber': '18',
  //         'room': '',
  //         'floor': '',
  //         'street': 'EF_Test',
  //         'landmark': '',
  //         'additionalInformation': '',
  //         'governate': 'Giza',
  //         'regionCity': 'Giza',
  //         'postalCode': '',
  //         'country': 'EG',
  //         'branchID': null
  //       },
  //       'type': 0,
  //       'id': '111111111',
  //       'name': 'test'
  //     },
  //     'issuer': {
  //       'address': {
  //         'buildingNumber': '00000',
  //         'room': null,
  //         'floor': null,
  //         'street': 'وحده رقم6 بمبني مجمع خدمات المنطقه الحره بالاسماعيليه',
  //         'landmark': null,
  //         'additionalInformation': ' ',
  //         'governate': 'Ismailia',
  //         'regionCity': 'Ismailia',
  //         'postalCode': '00000',
  //         'country': 'EG',
  //         'branchID': '0'
  //       },
  //       'type': 0,
  //       'id': '628787103',
  //       'name': 'اركديف ش ذ م م م'
  //     },
  //     'extraDiscountAmount': 0,
  //     'maxPercision': 2,
  //     'currenciesSold': 'EGP',
  //     'currencySegments': [
  //       {
  //         'currency': 'EGP',
  //         'currencyExchangeRate': null,
  //         'totalItemsDiscountAmount': 0,
  //         'totalAmount': 36685,
  //         'taxTotals': [],
  //         'netAmount': 36685,
  //         'totalDiscount': 0,
  //         'totalSales': 36685,
  //         'extraDiscountAmount': 0,
  //         'totalTaxableFees': 0
  //       }
  //     ]
  //   },
  //   {
  //     'submissionUUID': '7EHVRZ7QASRKSXZDRZ3WTH5G10',
  //     'dateTimeRecevied': '2022-06-14T19:26:01.5452084Z',
  //     'validationResults': {
  //       'status': 'Valid',
  //       'validationSteps': [
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-04',
  //           'stepId': '11'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-03',
  //           'stepId': '6'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-05',
  //           'stepId': '14'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-06',
  //           'stepId': '15'
  //         },
  //         {
  //           'status': 'Valid',
  //           'error': null,
  //           'stepName': 'Step-07',
  //           'stepId': '16'
  //         }
  //       ]
  //     },
  //     'transformationStatus': 'original',
  //     'statusId': 2,
  //     'status': 'Valid',
  //     'documentStatusReason': '',
  //     'cancelRequestDate': null,
  //     'rejectRequestDate': null,
  //     'cancelRequestDelayedDate': null,
  //     'rejectRequestDelayedDate': null,
  //     'declineCancelRequestDate': null,
  //     'declineRejectRequestDate': null,
  //     'canbeCancelledUntil': '2022-06-17T19:26:00.6954525Z',
  //     'canbeRejectedUntil': '2022-06-15T07:26:00.6954525Z',
  //     'submissionChannel': 3,
  //     'uuid': '4VKB8T091HZC6MQGRZ3WTH5G10',
  //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/4VKB8T091HZC6MQGRZ3WTH5G10/share/WA4YYVPXT7HG4HHFRZ3WTH5G104bceos1655234760',
  //     'purchaseOrderDescription': null,
  //     'totalItemsDiscountAmount': 0,
  //     'delivery': {
  //       'approach': null,
  //       'packaging': null,
  //       'dateValidity': null,
  //       'exportPort': null,
  //       'countryOfOrigin': null,
  //       'grossWeight': 0,
  //       'netWeight': null,
  //       'terms': null
  //     },
  //     'payment': {
  //       'bankName': null,
  //       'bankAddress': null,
  //       'bankAccountNo': null,
  //       'bankAccountIBAN': null,
  //       'swiftCode': null,
  //       'terms': null
  //     },
  //     'totalAmount': 516,
  //     'taxTotals': [],
  //     'netAmount': 516,
  //     'totalDiscount': 0,
  //     'totalSales': 516,
  //     'invoiceLines': [
  //       {
  //         'itemPrimaryName': null,
  //         'itemPrimaryDescription': null,
  //         'itemSecondaryName': null,
  //         'itemSecondaryDescription': null,
  //         'unitTypePrimaryName': 'Kilogram ( KG )',
  //         'unitTypePrimaryDescription': '',
  //         'unitTypeSecondaryName': '',
  //         'unitTypeSecondaryDescription': '',
  //         'salesTotalForeign': 516,
  //         'netTotalForeign': 516,
  //         'totalForeign': 516,
  //         'totalTaxableFeesForeign': 0,
  //         'itemsDiscountForeign': 0,
  //         'valueDifferenceForeign': 0,
  //         'discountForeign': {
  //           'amountForeign': 0,
  //           'rate': 0,
  //           'amount': 0
  //         },
  //         'lineTaxableItems': [],
  //         'description': 'PPS PI Pressure Injectable Safety Huber Needle',
  //         'itemType': 'GS1',
  //         'itemCode': '13661234011305',
  //         'unitType': 'KGM',
  //         'quantity': 2,
  //         'unitValue': {
  //           'currencySold': 'EGP',
  //           'amountSold': null,
  //           'amountEGP': 258,
  //           'currencyExchangeRate': null
  //         },
  //         'factoryUnitValue': null,
  //         'salesTotal': 516,
  //         'discount': {
  //           'rate': 0,
  //           'amount': 0
  //         },
  //         'taxableItems': null,
  //         'internalCode': '',
  //         'itemsDiscount': 0,
  //         'netTotal': 516,
  //         'totalTaxableFees': 0,
  //         'valueDifference': 0,
  //         'total': 516
  //       }
  //     ],
  //     'references': [],
  //     'salesOrderDescription': null,
  //     'salesOrderReference': null,
  //     'proformaInvoiceNumber': null,
  //     'signatures': [],
  //     'purchaseOrderReference': null,
  //     'internalID': '921904909388',
  //     'taxpayerActivityCode': '0472',
  //     'dateTimeIssued': '2022-06-14T19:25:59Z',
  //     'documentTypeVersion': '0.9',
  //     'documentType': 'i',
  //     'documentTypeNamePrimaryLang': 'Invoice',
  //     'documentTypeNameSecondaryLang': 'فاتورة',
  //     'receiver': {
  //       'address': {
  //         'buildingNumber': '18',
  //         'room': '',
  //         'floor': '',
  //         'street': 'EF_Test',
  //         'landmark': '',
  //         'additionalInformation': '',
  //         'governate': 'Giza',
  //         'regionCity': 'Giza',
  //         'postalCode': '',
  //         'country': 'EG',
  //         'branchID': null
  //       },
  //       'type': 0,
  //       'id': '111111111',
  //       'name': 'test'
  //     },
  //     'issuer': {
  //       'address': {
  //         'buildingNumber': '00000',
  //         'room': null,
  //         'floor': null,
  //         'street': 'وحده رقم6 بمبني مجمع خدمات المنطقه الحره بالاسماعيليه',
  //         'landmark': null,
  //         'additionalInformation': ' ',
  //         'governate': 'Ismailia',
  //         'regionCity': 'Ismailia',
  //         'postalCode': '00000',
  //         'country': 'EG',
  //         'branchID': '0'
  //       },
  //       'type': 0,
  //       'id': '628787103',
  //       'name': 'اركديف ش ذ م م م'
  //     },
  //     'extraDiscountAmount': 0,
  //     'maxPercision': 2,
  //     'currenciesSold': 'EGP',
  //     'currencySegments': [
  //       {
  //         'currency': 'EGP',
  //         'currencyExchangeRate': null,
  //         'totalItemsDiscountAmount': 0,
  //         'totalAmount': 516,
  //         'taxTotals': [],
  //         'netAmount': 516,
  //         'totalDiscount': 0,
  //         'totalSales': 516,
  //         'extraDiscountAmount': 0,
  //         'totalTaxableFees': 0
  //       }
  //     ]
  //   }
  // ]
  const getDataFromReferencesList = (references, locale, returnedObject, issuerId, isCopy) => {
    if (!!references?.length) {
      let firstRef = references[0]
      let issuerType = receiverTypes[firstRef?.issuer?.type]
      let issuerCountry = countryCodes?.filter(country => country?.key?.toString() === firstRef?.issuer?.address?.country?.toString())?.shift()
      let receiverType = receiverTypes[firstRef?.receiver?.type]
      let receiverCountry = countryCodes?.filter(country => country?.key?.toString() === firstRef?.receiver?.address?.country?.toString())?.shift()

      let newCurrencies = [...currencies]
      firstRef?.currencySegments?.forEach((curr) => {
        let currencyObj = curr.currency?.toString() !== 'EGP' && currencyList?.filter(curObj => curObj.key?.toString() === curr.currency?.toString())
        if (!!currencyObj?.length) {
          newCurrencies.push({
            id: newCurrencies.length,
            key: curr.currency,
            name_en: currencyObj[0]?.name_en || '',
            name_ar: currencyObj[0]?.name_ar || '',
            rate: curr.currencyExchangeRate
          })
        }
      })
      setCurrencies(newCurrencies)
      let invoice = {
        'step2': {
          taxpayerActivityCode: firstRef?.taxpayerActivityCode || '',
          issuerType: issuerType?.key || firstRef?.issuer?.type || 'B',
          issuerID: firstRef?.issuer?.id || issuerId || '',
          issuerName: firstRef?.issuer?.name || '',
          issuerBranchID: firstRef?.issuer?.address?.branchID || '0',
          issuerAddress: {
            ...Object.fromEntries(Object.entries(firstRef?.issuer?.address)?.map(([_, v]) => [_, v || ''])),
            countryName: !!Object.keys(issuerCountry || {}).length ? issuerCountry[`name_${locale}`] : ''
          },
          receiverType: receiverType?.key || firstRef?.receiver?.type || 'B',
          receiverID: firstRef?.receiver?.id || '',
          receiverName: firstRef?.receiver?.name || '',
          receiverBranchID: firstRef?.receiver?.address?.branchID || '',
          receiverAddress: {
            ...Object.fromEntries(Object.entries(firstRef?.receiver?.address).map(([_, v]) => [_, v || ''])),
            countryName: !!Object.keys(receiverCountry || {}).length ? receiverCountry[`name_${locale}`] : ''
          }
        },
        'step3': calculateReferencesItems(references, locale, isCopy),
        'step4': {
          purchaseOrderReference: firstRef?.purchaseOrderReference || '',
          purchaseOrderDescription: firstRef?.purchaseOrderDescription || '',
          salesOrderReference: firstRef?.salesOrderReference || '',
          salesOrderDescription: firstRef?.salesOrderDescription || '',
          proformaInvoiceNumber: firstRef?.proformaInvoiceNumber || '',
          bankName: firstRef?.payment?.bankName || '',
          bankAddress: firstRef?.payment?.bankAddress || '',
          bankAccountNo: firstRef?.payment?.bankAccountNo || '',
          bankAccountIBAN: firstRef?.payment?.bankAccountIBAN || '',
          swiftCode: firstRef?.payment?.swiftCode || '',
          paymentTerms: firstRef?.payment?.terms || ''
        },
        'step5': {
          approach: firstRef?.delivery?.approach || '',
          packaging: firstRef?.delivery?.packaging || '',
          dateValidity: firstRef?.delivery?.dateValidity || '',
          exportPort: firstRef?.delivery?.exportPort || '',
          countryOfOrigin: firstRef?.delivery?.countryOfOrigin || '',
          grossWeight: firstRef?.delivery?.grossWeight || 0,
          netWeight: firstRef?.delivery?.netWeight || 0,
          deliveryTerms: firstRef?.delivery?.terms || ''
        }
      }
      if (!!returnedObject) {
        return invoice
      } else {
        setInvoiceData((prevState) => ({ ...prevState, ...invoice }))
      }
    }
  }
  const getTaxableItems = (taxesList, locale, isCopy, isForeign) => {
    let returnedObj = {}
    if (!!taxesList?.length) {
      let allTaxes = [...taxTypes, ...nonTaxableTaxTypes]
      let allWithdrawTaxes = allTaxes?.filter(item => !!item?.withdraw)?.map(item => item.key)
      let calculatedTaxes = 0
      let calculatedTaxesWithoutT1 = 0
      let taxableItems = []
      taxesList.forEach((item, index) => {
        let taxType = [...taxTypes, ...nonTaxableTaxTypes].filter(tax => tax?.key?.toString() === item?.taxType?.toString())
        let taxSubType = taxSubtypes.filter(tax => tax?.key?.toString() === item?.subType?.toString() && tax?.TaxtypeReference?.toString() === item?.taxType?.toString())
        taxableItems.push({
          id: index + 1,
          type: item?.taxType || '',
          typeName: taxType?.length ? taxType[0][`name_${locale}`] : '',
          subType: item?.subType || '',
          subTypeName: taxSubType?.length ? taxSubType[0][`name_${locale}`] : '',
          rate: item?.rate || 0,
          value: item?.amount || 0,
          calculatedValue: item?.amount || 0,
          valueEdit: false,
          fixedAmount: taxType?.length ? taxType[0]?.fixedAmount : false
        })
        if (!!allWithdrawTaxes.includes(item.taxType)) {
          calculatedTaxes -= parseFloat(item.value) || 0
          calculatedTaxesWithoutT1 -= (item.taxType === 'T1') ? 0 : parseFloat(item.value) || 0
        } else {
          calculatedTaxes += parseFloat(item.value) || 0
          calculatedTaxesWithoutT1 += (item.taxType === 'T1') ? 0 : parseFloat(item.value) || 0
        }
      })

      returnedObj = {
        taxableItems: taxableItems,
        totalTaxableItems: calculatedTaxes,
        calculatedTaxesWithoutT1: calculatedTaxesWithoutT1,
        originItemTaxesValues: !!isCopy ? {} : {
          taxableItems: taxableItems,
          totalTaxableItems: calculatedTaxes,
          calculatedTaxesWithoutT1: calculatedTaxesWithoutT1
        }
      }
    }

    return returnedObj
  }
  const calculateReferencesItems = (references, locale, isCopy) => {

    let newValues = {
      totalSalesAmount: 0,
      totalDiscountAmount: 0,
      netAmount: 0,
      extraDiscountAmount: 0,
      totalItemsDiscountAmount: 0,
      totalAmount: 0,
      invoiceLines: []
    }
    let allItemsTaxes = references.map(item => item.taxTotals).reduce((a, b) => !!b ? a.concat(b) : a, []).reduce(function(r, a) {
      r[a.taxType] = r[a.taxType] || []
      r[a.taxType].push(a)
      return r
    }, Object.create(null))


    let calculatedTaxes = Object.keys(allItemsTaxes || {})?.map(item => {
      let taxObj = {
        taxType: item,
        amount: 0,
        amountEdit: false,
        calculatedAmount: 0
      }
      allItemsTaxes[item]?.forEach(tax => {
        taxObj.calculatedAmount += parseFloat(tax.amount) || 0
      })
      taxObj.calculatedAmount = calculateDecimal(taxObj.calculatedAmount)
      if (!taxObj?.amountEdit) {
        taxObj.amount = taxObj.calculatedAmount
      }
      return taxObj
    }) || []
    console.log('calculatedTaxes', calculatedTaxes)

    references.forEach(invoice => {
      newValues.totalSalesAmount += !!savedEntityId ? invoice.totalSalesAmount : invoice.totalSales
      newValues.totalDiscountAmount += !!savedEntityId ? invoice.totalDiscountAmount : invoice.totalDiscount
      newValues.netAmount += invoice.netAmount
      newValues.extraDiscountAmount += invoice.extraDiscountAmount
      newValues.totalItemsDiscountAmount += invoice.totalItemsDiscountAmount
      newValues.totalAmount += invoice.totalAmount
      newValues.invoiceLines = [...newValues.invoiceLines, ...invoice.invoiceLines.map(item => ({
        ...item,
        invoiceUUID: invoice.uuid
      }))]
    })
    let newLines = []
    newValues.invoiceLines.forEach((item, index) => {
      let isForeign = !!item?.unitValue?.currencySold && item?.unitValue?.currencySold !== 'EGP'
      newLines.push({
        id: index + 1,
        itemType: item?.itemType || 'GS1',
        itemCode: item?.itemCode || '',
        itemName: (locale === 'ar') ? item?.itemSecondaryName || item?.itemPrimaryName || item?.itemName || '' : item?.itemPrimaryName || item?.itemName || '',
        description: item?.description || '',
        itemObject: {},
        internalCode: item?.internalCode || '',

        unitCalculatedValue: !!isForeign ? (item?.unitValue?.amountSold || 0) : (item?.unitValue?.amountEGP || 0),
        unitAmount: !!isForeign ? (item?.unitValue?.amountSold || 0) : (item?.unitValue?.amountEGP || 0),
        currencyRate: { key: item?.unitValue?.currencySold || 'EGP', rate: item?.unitValue?.currencyExchangeRate || 1 },
        amountSold: item?.unitValue?.currencySold || 'EGP',

        unitType: item?.unitType || 'KGM',
        quantity: item?.quantity || 1,

        weightUnitType: item?.weightUnitType || '',
        weightQuantity: item?.weightQuantity || 0,

        calculatedSalesTotal: !!isForeign ? (item?.salesTotalForeign || 0) : (item?.salesTotal || 0),
        salesTotalEdit: false,
        salesTotal: !!isForeign ? (item?.salesTotalForeign || 0) : (item?.salesTotal || 0),

        discountRate: !!isForeign ? (item?.discountForeign?.rate || 0) : (item?.discount?.rate || 0),
        discountValue: !!isForeign ? (item?.discountForeign?.amount || 0) : (item?.discount?.amount || 0),
        discountValueEdit: false,
        discountCalculatedValue: !!isForeign ? (item?.discountForeign?.amount || 0) : (item?.discount?.amount || 0),

        netTotal: !!isForeign ? (item?.netTotalForeign || 0) : (item?.netTotal || 0),
        netTotalEdit: false,
        calculatedNetTotal: !!isForeign ? (item?.netTotalForeign || 0) : (item?.netTotal || 0),

        totalTaxableFees: !!isForeign ? (item?.totalTaxableFeesForeign || 0) : (item?.totalTaxableFees || 0),
        totalTaxableFeesEdit: false,
        calculatedTotalTaxableFees: !!isForeign ? (item?.totalTaxableFeesForeign || 0) : (item?.totalTaxableFees || 0),


        valueDifference: !!isForeign ? (item?.valueDifferenceForeign || 0) : (item?.valueDifference || 0),
        itemsDiscount: !!isForeign ? (item?.itemsDiscountForeign || 0) : (item?.itemsDiscount || 0),

        total: !!isForeign ? (item?.totalForeign || 0) : (item?.total || 0),
        totalEdit: false,
        calculatedTotal: !!isForeign ? (item?.totalForeign || 0) : (item?.total || 0),

        invoiceUUID: !!isCopy ? '' : (item?.invoiceUUID || ''),

        originItemValues: !!isCopy ? {} : {
          unitAmount: !!isForeign ? (item?.unitValue?.amountSold || 0) : (item?.unitValue?.amountEGP || 0),
          quantity: item?.quantity || 1,
          weightQuantity: item?.weightQuantity || 0,
          salesTotal: !!isForeign ? (item?.salesTotalForeign || 0) : (item?.salesTotal || 0),
          discountRate: !!isForeign ? (item?.discountForeign?.rate || 0) : (item?.discount?.rate || 0),
          discountValue: !!isForeign ? (item?.discountForeign?.amount || 0) : (item?.discount?.amount || 0),
          netTotal: !!isForeign ? (item?.netTotalForeign || 0) : (item?.netTotal || 0),
          totalTaxableFees: !!isForeign ? (item?.totalTaxableFeesForeign || 0) : (item?.totalTaxableFees || 0),
          valueDifference: !!isForeign ? (item?.valueDifferenceForeign || 0) : (item?.valueDifference || 0),
          itemsDiscount: !!isForeign ? (item?.itemsDiscountForeign || 0) : (item?.itemsDiscount || 0),
          total: !!isForeign ? (item?.totalForeign || 0) : (item?.total || 0)
        },

        ...getTaxableItems(item?.lineTaxableItems || item?.taxableItems || [], locale, isCopy, isForeign)
      })
    })
    return {
      invoiceLines: newLines || [],

      calculatedTotalSalesAmount: calculateDecimal(newValues.totalSalesAmount),
      totalSalesAmountEdit: false,
      totalSalesAmount: calculateDecimal(newValues.totalSalesAmount),

      calculatedTotalDiscountAmount: calculateDecimal(newValues.totalDiscountAmount),
      totalDiscountAmountEdit: false,
      totalDiscountAmount: calculateDecimal(newValues.totalDiscountAmount),

      calculatedNetAmount: calculateDecimal(newValues.netAmount),
      netAmountEdit: false,
      netAmount: calculateDecimal(newValues.netAmount),

      currency: references[0]?.currenciesSold || 'EGP',

      calculatedTotalItemsDiscountAmount: calculateDecimal(newValues.totalItemsDiscountAmount),
      totalItemsDiscountAmountEdit: false,
      totalItemsDiscountAmount: calculateDecimal(newValues.totalItemsDiscountAmount),

      taxTotals: calculatedTaxes,

      extraDiscountAmount: calculateDecimal(newValues.extraDiscountAmount),

      calculatedTotalAmount: calculateDecimal(newValues.totalAmount),
      totalAmountEdit: false,
      totalAmount: calculateDecimal(newValues.totalAmount)
    }
  }

  const signInvoice = (certificateNumber, closeDialog) => {
    if (!!keycloak?.authenticated && !!Object.keys(invoiceData || {}).length && !!certificateNumber) {
      setInvoiceSubmissionLoading(true)
      let currentInvoice = InvoiceSubmitPayload(invoiceData, invoiceSubType, hasReferences, true) || {}
      ListingServices.signInvoices({
        'certificateSerialNumber': certificateNumber,
        'contentToSign': Buffer.from(JSON.stringify(currentInvoice)).toString('base64')
      }, setInvoiceSubmissionLoading, null, intl.formatMessage({ id: 'invoice.signing.error' })).then((result) => {

        if (!!result && !!result.data && !!result.data.signature) {
          handleNotificationAlert({
            type: 'done',
            message: intl.formatMessage({ id: 'Invoice.sign.Done' }),
            color: 'success'
          }, 'success')
          setTimeout(() => submitInvoice(currentInvoice, result.data.signature, closeDialog), 100)
        } else {
          setInvoiceSubmissionLoading(false)
        }
      }).then(() => {
        setInvoiceSubmissionLoading(false)
      })

    }
  }

  const handleSaveInvoiceEntity = (e, entityType, values, key, tempData, formikActions, closeDialog) => {
    setDraftInvoiceLoading(true)
    e?.preventDefault()
    e?.stopPropagation()
    if (key === 'step1' && !!values?.referencesList?.length) {
      getDataFromReferencesList(values?.referencesList, locale)
    }
    setTimeout(() => {
      let invoice = !!values ? { ...invoiceData, [key]: values } : { ...invoiceData }
      // setInvoiceData((prevState) => ({ ...prevState, [key]: values }))
      ListingServices.SaveInvoiceEntity(filterData({
          id: (savedEntityType === entityType && !!savedEntityId) ? parseInt(savedEntityId) : null,
          simple: invoiceSubType === 'simple',
          document: {
            ...InvoiceSubmitPayload(invoice, invoiceSubType, hasReferences, true, true), signatures: [{
              signatureType: 'I',
              value: ''
            }]
          },
          ...(tempData || {})
        }),
        entityType, formikActions?.setSubmitting || setDraftInvoiceLoading, formikActions, intl.formatMessage({ id: `invoice.saveEntity.${entityType}.error` }))
        .then((result) => {
          if (!!result && !!result.data && result.data?.responseStatus === 'OK') {
            handleNotificationAlert({
              type: 'done',
              message: intl.formatMessage({ id: `invoice.saveEntity.${entityType}.success` }),
              color: 'success'
            }, 'success')
            if (!!closeDialog) {
              closeDialog()
              setTimeout(() => history.push((entityType === 'template') ? NamedRoutes.templates : NamedRoutes.drafts), 300)
            } else {
              setTimeout(() => history.push((entityType === 'template') ? NamedRoutes.templates : NamedRoutes.drafts), 150)
            }
          }
        }).then(() => {
        formikActions?.setSubmitting(false)
        setDraftInvoiceLoading(false)
      })

      //
      // FormikActions.setSubmitting(false)
    }, 100)
  }

  const submitInvoice = (currentInvoice, signature, closeDialog) => {
    if (!!keycloak?.authenticated && !!Object.keys(invoiceData || {}).length) {
      // console.log(InvoiceSubmitPayload(invoiceData, invoiceSubType))
      // encoded = btoa(JSON.stringify(obj))
      setInvoiceSubmissionLoading(true)
      ListingServices.submitInvoices(
        !!signature ? InvoiceSignatureSubmitPayload(currentInvoice, signature) : InvoiceSubmitPayload(invoiceData, invoiceSubType, hasReferences, false, signature),
        { headers: { serviceId: Configuration.HEADER_SERVICE_ID } }, setInvoiceSubmissionLoading,
        null, intl.formatMessage({ id: 'invoice.submit.error' })).then((result) => {
        if (!!closeDialog) {
          closeDialog()
        }
        if (!!result && !!result.data && !!result.data.submissionId) {
          setInvoiceSubmissionUUID(result.data.submissionId)
          setTimeout(() => handleNextStep(), 300)
          setIsLocked(true)
        } else if (result?.data?.rejectedDocuments?.length) {
          let message = <FormattedMessage id='invoice.submit.error'/>
          let messagesList = []
          if (result.data?.rejectedDocuments[0]?.error?.details?.length) {
            result.data?.rejectedDocuments[0]?.error?.details.forEach(msg => {
              messagesList.push(<>
                <strong>{`${!!msg.code ? msg.code : result.data?.rejectedDocuments[0]?.error?.code || ''} ${!!msg.target ? `(${msg.target})` : ''}`}:</strong> {msg.message}</>)
            })
          } else {
            if (result?.data?.rejectedDocuments[0]?.error?.message) {
              message = result.data?.rejectedDocuments[0]?.error?.message
            }
          }
          if (!!messagesList?.length) {
            messagesList.forEach(msg => {
              handleNotificationAlert({
                type: 'defence',
                message: msg,
                color: 'error'
              }, 'error')
            })
          } else {
            handleNotificationAlert({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        setInvoiceSubmissionLoading(false)
      })

    }
  }

  const [currentInvoiceDetails, setCurrentInvoiceDetails] = React.useState({})
  const [currentInvoiceErrors, setCurrentInvoiceErrors] = React.useState([])
  const [currentInvoiceLoading, setCurrentInvoiceLoading] = React.useState(false)
  const getInvoiceDetails = (uuid, isExport) => {
    if (!!keycloak?.authenticated && !!uuid) {
      setCurrentInvoiceLoading(true)
      ListingServices.getMsInvoiceData(uuid, intl.formatMessage({ id: 'single.invoice.Error' })).then((result) => {
        if (!!result && !!result.data) {
          if (result?.data?.issuer?.id?.toString() === trn && (result?.data?.documentType?.toLowerCase() === (!!isExport ? 'ei' : 'i')) && result?.data?.status === 'Valid'
            && !result?.data?.cancelRequestDate && !result?.data?.rejectRequestDate) {
            setCurrentInvoiceDetails(result.data)
          } else {
            setCurrentInvoiceErrors([intl.formatMessage({ id: `validationSchema.reference.Error${!!isExport?'.export':''}` })])
          }
        } else if (!!result.response.data?.error?.details?.length) {
          setCurrentInvoiceErrors(result.response.data?.error?.details?.map(msg => msg.message))
        }
      }).then(() => {
        setCurrentInvoiceLoading(false)
      })
    }
  }

  const [currentReceiverDetails, setCurrentReceiverDetails] = React.useState(null)
  const [currentReceiverDetailsLoading, setCurrentReceiverDetailsLoading] = React.useState(false)
  const [currentReceiverDetailsFailure, setCurrentReceiverDetailsFailure] = React.useState(false)
  const getReceiverDetails = (trn) => {
    if (!!keycloak?.authenticated && !!trn) {
      setCurrentReceiverDetailsLoading(true)
      setCurrentReceiverDetailsFailure(false)
      AuthServices.getReceiverDetails(trn, intl.formatMessage({ id: 'currentReceiver.details.Error' })).then((result) => {
        if (!!result && !!result.data && !!result.data.data && !!Object.keys(result.data.data).length) {
          setCurrentReceiverDetails(result.data.data)
        } else {
          setCurrentReceiverDetailsFailure(true)
          setCurrentReceiverDetails({})
        }
      }).then(() => {
        setCurrentReceiverDetailsLoading(false)
      })
    }
  }
  const resetReceiverDetails = () => {
    setCurrentReceiverDetailsFailure(false)
    setCurrentReceiverDetailsLoading(false)
    setCurrentReceiverDetails(null)
  }

  const [invoiceActiveStep, setInvoiceActiveStep] = React.useState(0)
  const [invoiceStepsTrail, setInvoiceStepsTrail] = React.useState(new Set())
  const [invoiceStepsCompleted, setInvoiceStepsCompleted] = React.useState(new Set())

  const handleBackStep = () => {
    setInvoiceActiveStep((prevActiveStep) => ((prevActiveStep === 2 && !!hasReferences) ? prevActiveStep - 2 : (prevActiveStep === 5 && (invoiceSubType !== 'full' || !!hasReferences)) ? prevActiveStep - 3 : prevActiveStep - 1))
  }

  const handleGoToStep = (step) => {
    if (!isLocked) {
      setInvoiceActiveStep(step)
    }
  }

  const isInvoiceStepComplete = (step) => {
    return invoiceStepsCompleted.has(step)
  }

  const inInvoiceStepsTrail = (step) => {
    return invoiceStepsTrail.has(step)
  }

  const resetInvoiceDetails = () => {
    setInvoiceData({})
    setInvoiceSubType('full')
    setInvoiceActiveStep(0)
    setInvoiceStepsTrail(new Set())
    setInvoiceStepsCompleted(new Set())
    resetReceiverDetails()
    setHasReferences(false)
    setInvoiceSubmissionLoading(false)
    setInvoiceSubmissionUUID('')
    setIsLocked(false)
  }

  const invoiceSteps = [
    {
      key: 0,
      title: <FormattedMessage id='Invoice.Create.Step1.Title'/>,
      icon: <TuneSharpIcon/>,
      content: <InvoiceCreateStep1
        hasDrafted={!!savedEntityId}
        savedTemplateData={savedTemplateData}
        handleSaveInvoiceEntity={handleSaveInvoiceEntity}
        invoiceData={invoiceData}
        currentInvoiceDetails={currentInvoiceDetails}
        currentInvoiceErrors={currentInvoiceErrors}
        currentInvoiceLoading={currentInvoiceLoading}
        getInvoiceDetails={getInvoiceDetails}
        handleReferencesChange={handleReferencesChange}
        onSubmit={invoiceStepSubmit}
        locale={locale}
        handleInvoiceSubTypeChange={handleInvoiceSubTypeChange}/>
    },
    {
      key: 1,
      title: <FormattedMessage id='Invoice.Create.Step2.Title'/>,
      icon: <TransferWithinAStationSharpIcon/>,
      hide: !!hasReferences,
      content: <AuthConsumer>
        {({ taxpayerData }) => (
          <InvoiceCreateStep2
            taxpayerData={taxpayerData}
            locale={locale}
            invoicePersonalLimit={invoicePersonalLimit}
            hasDrafted={!!savedEntityId}
            savedTemplateData={savedTemplateData}
            handleSaveInvoiceEntity={handleSaveInvoiceEntity}
            getReceiverDetails={getReceiverDetails}
            currentReceiverDetails={currentReceiverDetails}
            resetReceiverDetails={resetReceiverDetails}
            invoiceData={invoiceData}
            onSubmit={invoiceStepSubmit}
            handleBackStep={handleBackStep}/>
        )}
      </AuthConsumer>
    },
    {
      key: 2,
      title: <FormattedMessage id='Invoice.Create.Step3.Title'/>,
      icon: <PostAddSharpIcon/>,
      content: <InvoiceCreateStep3
        locale={locale}
        invoiceData={invoiceData}
        hasReferences={hasReferences}
        isCopyInvoice={isCopyInvoice}
        currencies={currencies}
        invoicePersonalLimit={invoicePersonalLimit}
        savedTemplateData={savedTemplateData}
        handleSaveInvoiceEntity={handleSaveInvoiceEntity}
        updateCurrenciesList={updateCurrenciesList}
        onSubmit={invoiceStepSubmit}
        handleBackStep={handleBackStep}/>
    },
    {
      key: 3,
      title: <FormattedMessage id='Invoice.Create.Step4.Title'/>,
      icon: <CreditCardIcon/>,
      hide: invoiceSubType !== 'full' || !!hasReferences,
      content: <InvoiceCreateStep4
        invoiceData={invoiceData}
        savedTemplateData={savedTemplateData}
        handleSaveInvoiceEntity={handleSaveInvoiceEntity}
        onSubmit={invoiceStepSubmit}
        handleBackStep={handleBackStep}/>
    },
    {
      key: 4,
      title: <FormattedMessage id='Invoice.Create.Step5.Title'/>,
      icon: <LocalShippingSharpIcon/>,
      hide: invoiceSubType !== 'full' || !!hasReferences,
      content: <InvoiceCreateStep5
        invoiceData={invoiceData}
        savedTemplateData={savedTemplateData}
        handleSaveInvoiceEntity={handleSaveInvoiceEntity}
        onSubmit={invoiceStepSubmit}
        handleBackStep={handleBackStep}/>
    },
    {
      key: 5,
      title: <FormattedMessage id='Invoice.Create.Step6.Title'/>,
      icon: <LocalPrintshopSharpIcon/>,
      content: <AuthConsumer>
        {({ taxpayerData }) => (
          <InvoiceCreateStep6
            locale={locale}
            invoiceSubmissionLoading={invoiceSubmissionLoading}
            savedTemplateData={savedTemplateData}
            handleSaveInvoiceEntity={handleSaveInvoiceEntity}
            signInvoice={signInvoice}
            invoiceData={invoiceData}
            onSubmit={submitInvoice}
            taxpayerData={taxpayerData}
          />
        )}
      </AuthConsumer>
    },
    {
      key: 6,
      title: <FormattedMessage id='Invoice.Create.Step7.Title'/>,
      icon: <CheckIcon/>,
      content: <InvoiceCreateStep7 invoiceSubmissionUUID={invoiceSubmissionUUID} resetInvoice={resetInvoiceDetails}/>
    }
  ]

  const getInvoiceStepContent = (stepIndex) => {
    let content = ''
    if (stepIndex >= 0 && stepIndex < invoiceSteps.length) {
      content = invoiceSteps[stepIndex].content
    }
    return content
  }

  const handleNextStep = (reset) => {
    const newCompleted = new Set(reset ? new Set() : invoiceStepsCompleted)
    newCompleted.add(invoiceActiveStep)
    if (invoiceActiveStep + 2 === invoiceSteps.length) {
      newCompleted.add(invoiceActiveStep + 1)
    }
    setInvoiceStepsCompleted(newCompleted)

    const newStepsTrail = new Set(reset ? new Set() : invoiceStepsTrail)
    newStepsTrail.add(invoiceActiveStep + 1)
    if (invoiceActiveStep === 0 && !!hasReferences) {
      newStepsTrail.add(1)
    }
    if (invoiceActiveStep === 2 && (invoiceSubType !== 'full' || !!hasReferences)) {
      newStepsTrail.add(invoiceActiveStep + 2)
      newStepsTrail.add(invoiceActiveStep + 3)
    }
    setInvoiceStepsTrail(newStepsTrail)

    setInvoiceActiveStep((prevActiveStep) => ((prevActiveStep === 0 && !!hasReferences) ? prevActiveStep + 2 : (prevActiveStep === 2 && (invoiceSubType !== 'full' || !!hasReferences)) ? prevActiveStep + 3 : prevActiveStep + 1))
  }


  return (
    <CreateInvoiceContext.Provider value={{

      invoiceActiveStep: invoiceActiveStep,
      invoiceSteps: invoiceSteps,
      getInvoiceStepContent,
      handleNextStep,
      handleBackStep,
      handleGoToStep,
      isInvoiceStepComplete,
      inInvoiceStepsTrail,

      handleInvoiceSubTypeChange,
      invoiceSubType,

      currentReceiverDetailsLoading,
      currentReceiverDetailsFailure,

      draftInvoiceLoading

    }}>
      {children}
    </CreateInvoiceContext.Provider>
  )
}
const CreateInvoiceConsumer = CreateInvoiceContext.Consumer

export { CreateInvoiceProvider, CreateInvoiceConsumer }
